module.exports = __webpack_public_path__ + "img/chevron-right.a92b8f4b.svg";